import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import delhimap from "../../assets/icons/delhiMap.svg";
import PollingTableNew from "../../components/PollingTable/PollingTableNew";
import appicon from "../../assets/icons/Aam_Aadmi_Party_flag_(2).svg@2x.png";
import congFlag from "../../assets/icons/congFlag.svg";
import bjpFlag from "../../assets/icons/BJP_Flag.svg";
import othersFlag from "../../assets/icons/0thersflag.svg";
import { useContext, useEffect, useMemo, useState } from "react";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";
import { getPollResults } from "../../redux/actions/privateApiAction";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import {
  getPartyMetaData,
  getPolls,
  getPollsYears,
  getStateCountry,
} from "../../redux/actions/pollingAction";
import HorizontalBar from "../../common/horizontalBar";
import PredictionContext from "../../context/predictionFlow/predictionContext";
import CountryContext from "../../context/countryContext/countryContext";
import PollingTable from "../../components/PollingTable/PollingTableD";
import { formatBreadcrumbName } from "../../helpers/utilities";

// import { Tooltip } from "@material-tailwind/react";

const Delhipolls = () => {
  const location = useLocation();
  let { slug } = useParams();

  const heading = location?.pathname?.split("/")?.[3];
  const slug1 = location?.pathname?.split("/")?.[1];

  const isVerified = localStorage.getItem("accessToken");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { indiaPollsResult } = useSelector((state) => state?.privateReducer);
  const { delhiPollsYearsResponse, delhiElectionData, partyMetaDataList, stateCountry } =
    useSelector((state) => state.pollWeb);
  console.log("🚀 ~ Delhipolls ~ stateCountry:", stateCountry)

  const [searchData, setSearchData] = useState({
    year: '',
    type: "poll_prediction",
  });

  const [showPie, setShowPie] = useState(true);
  const [loading, setLoading] = useState(true);

  // Get search params
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  // Memoize pollPayload to prevent unnecessary recalculations
  const pollPayload = useMemo(() => {
    return type
      ? { country: localStorage.getItem("country") }
      : {
        country: localStorage.getItem("country"),
        state: localStorage.getItem("state"),
      };
  }, [type]);

  // Memoize params to prevent unnecessary recalculations
  const params = useMemo(() => {
    return `type=${searchData?.type}&year=${searchData?.year}`;
  }, [searchData?.type, searchData?.year]);

  // Fetch state/country data when slug1 or heading changes
  const statecountry = useMemo(() => {
    return type
      ? { country: slug1 }
      : {
        country: slug1,
        state: heading
      };
  }, [type]);
  useEffect(() => {
    dispatch(getStateCountry(statecountry));
  }, [dispatch, slug1, heading]);

  // Initialize data and set first available year
  useEffect(() => {
    const fetchData = async () => {
      if (stateCountry) {

        localStorage.setItem("country", stateCountry.country_id);
        localStorage.setItem("state", stateCountry.state_id);

        try {
          await dispatch(getPollsYears(pollPayload));
          await dispatch(getPartyMetaData(pollPayload));
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };

    fetchData();
  }, [dispatch, pollPayload, stateCountry]);

  // Set initial year and fetch data when years are available
  useEffect(() => {
    if (delhiPollsYearsResponse?.length > 0) {
      const firstYear = delhiPollsYearsResponse[0]?.year;

      setSearchData(prev => ({
        ...prev,
        year: firstYear
      }));

      // ✅ Auto fetch only the first time (initial load)
      const fetchParams = `type=${searchData.type}&year=${firstYear}`;
      setLoading(true);
      Promise.all([
        dispatch(getPollResults(pollPayload, fetchParams)),
        dispatch(getPolls(pollPayload, fetchParams))
      ])
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    }
  }, [delhiPollsYearsResponse, dispatch, pollPayload]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    setLoading(true);
    Promise.all([
      dispatch(getPollResults(pollPayload, params)),
      dispatch(getPolls(pollPayload, params))
    ])
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  };
  const partyInfo = {};

  partyMetaDataList?.forEach((party) => {
    const key = party?.abbreviation?.toUpperCase();
    partyInfo[key] = {
      color: party?.color_code || "#CCCCCC", // fallback
      logo: party?.file || othersFlag, // fallback
      name: party?.abbreviation?.toUpperCase() || key, // readable name
    };
  });
  const partySet = new Set();
  Object.keys(indiaPollsResult || {}).forEach((key) => {
    console.log("🚀 ~ Delhipolls ~ indiaPollsResult:", indiaPollsResult)
    const partyAbbreviation = key.split("_")[0]; // take everything before first "_"  
    console.log("🚀 ~ Delhipolls ~ partyAbbreviation:", partyAbbreviation)
    if (partyAbbreviation) {
      partySet.add(partyAbbreviation.toUpperCase()); // ensure consistent casing
    }
  });

  const barData = Array.from(partySet).map((party) => {
    console.log("🚀 ~ Delhipolls ~ party:", party)
    const info = partyInfo[party] || {};
    const voteKey =
      searchData?.type === "poll_prediction"
        ? `${party}_VoteShares`
        : `${party}_Voteshare_Result`;
    return {
      name: info.name || party,
      value: parseFloat(indiaPollsResult?.[voteKey] || 0),
      female: parseFloat(indiaPollsResult?.[`${party}_FEMALE_VoteShares`] || 0),
      male: parseFloat(indiaPollsResult?.[`${party}_MALE_VoteShares`] || 0),
      seat: parseFloat(indiaPollsResult?.[voteKey] || 0),
      color: info.color || "#CCCCCC",
    };
  });
  console.log("🚀 ~ Delhipolls ~ piedata:", barData)

  // const pieData = [
  //   {
  //     name: "APP",
  //     value: parseFloat(indiaPollsResult?.AAPSeats),
  //     female: parseFloat(indiaPollsResult?.appFemaleVShares),
  //     seat: parseFloat(indiaPollsResult?.AAPSeats),
  //     male: parseFloat(indiaPollsResult?.appMaleVShares),
  //     color: "#FDF000",
  //   },
  //   {
  //     name: "BJP",
  //     value: parseFloat(indiaPollsResult?.BJPSeats),
  //     female: parseFloat(indiaPollsResult?.bjpFemaleVShares),
  //     seat: parseFloat(indiaPollsResult?.BJPSeats),
  //     male: parseFloat(indiaPollsResult?.bjpMaleVShares),
  //     color: "#FF671F",
  //   },
  //   {
  //     name: "CON",
  //     value: parseFloat(indiaPollsResult?.INCSeats),
  //     female: parseFloat(indiaPollsResult?.incFemaleVShares),
  //     seat: parseFloat(indiaPollsResult?.INCSeats),
  //     male: parseFloat(indiaPollsResult?.incMaleVShares),
  //     color: "#4251A8",
  //   },
  //   {
  //     name: "OTH",
  //     value: parseFloat(indiaPollsResult?.OTHERSSeats),
  //     female: parseFloat(indiaPollsResult?.othersFemaleVShares),
  //     seat: parseFloat(indiaPollsResult?.OTHERSSeats),
  //     male: parseFloat(indiaPollsResult?.othersMaleVShares),
  //     color: "#AAAAAA",
  //   },
  // ];
  const COLORS = ["#FDF000", "#FF671F", "#4251A8", "#AAAAAA"];
  // const barData = [
  //   {
  //     name: "Aam Aadmi Party",
  //     result: indiaPollsResult?.AAPVoteShares,
  //     color: "bg-gradient-to-r via-amber-200 from-[#FDF000] to-white",
  //     icon: appicon,
  //   },
  //   {
  //     name: "Bhartiya Janta Party",
  //     result: indiaPollsResult?.BJPVoteShares,
  //     color: "bg-gradient-to-r via-[#FF671F] from-[#FF671F] to-orange-100",
  //     icon: bjpFlag,
  //   },
  //   {
  //     name: "Congress",
  //     result: indiaPollsResult?.INCVoteShares,
  //     color: "bg-gradient-to-r via-indigo-400 from-indigo-800 to-indigo-200",
  //     icon: congFlag,
  //   },
  //   {
  //     name: "Others",
  //     result: indiaPollsResult?.OTHERSVoteShares,
  //     color: "bg-gradient-to-r from-gray-500 to-white",
  //     icon: othersFlag,
  //   },
  // ];

  const generateGradient = (baseColor) => {
    if (!baseColor || baseColor.length < 4)
      return "bg-gradient-to-r from-gray-400 to-white";

    return `bg-gradient-to-r via-[${baseColor}] from-[${baseColor}] to-white`;
  };

  const pieData = Array.from(partySet).map((party) => {
    const info = partyInfo[party] || {};
    const voteKey =
      searchData?.type === "poll_prediction"
        ? `${party}_Seats`
        : `${party}_Seat_Result`;
    // const voteKey = `${party}_VoteShares`;
    const value = parseFloat(indiaPollsResult?.[voteKey] || 0);
    return {
      name: info.name || party,
      result: value,
      color: info?.color,
      icon: info.logo || othersFlag,
    };
  });
  console.log("🚀 ~ Delhipolls ~ barData:", pieData)

  // Sort the barData by name (case-insensitive)
  pieData.sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
  );

  // console.log("pieData", pieData);

  useEffect(() => {
    if (indiaPollsResult) {
      const hasSeats = barData.some((d) => d.seat > 0);
      setShowPie(hasSeats);
    }
  }, [indiaPollsResult]);

  const legendData = Array.from(
    new Map(
      barData
        .filter((d) => d.name && !d?.isGap)
        .map((d) => [d.name, { name: d.name, color: d.color }])
    ).values()
  );
  const CustomLegend = () => (
    <div className="flex flex-wrap gap-6 text-sm mt-2">
      {legendData?.map((entry) => (
        <div key={entry?.name} className="flex items-center gap-1">
          <div
            style={{
              width: 12,
              height: 12,
              backgroundColor: entry?.color,
              borderRadius: 20,
            }}
          />
          <span>{entry?.name}</span>
        </div>
      ))}
    </div>
  );

  return (
    <div className="bg_home flex flex-col pb-8">
      <div className="flex flex-row px-6 md:px-40 gap-4 text-[12px] font-semibold bg-[#E2E7EE]">
        <Link
          to={`/${slug1}/general-stories`}
          className={`py-2 nav-link-hover-poll ${location.pathname === `/${slug1}/general-stories`
            ? "font-bold current-page "
            : "text-[#7F8FA4]"
            }`}
        >
          General Stories
        </Link>
        <Link
          to={`/${slug1}/polling`}
          className={`py-2 mx-2 ${location.pathname === `/${slug1}/polling` ||
            location.pathname === `/${slug1}/polls/${slug}`
            ? "font-bold current-page "
            : "text-[#7F8FA4]"
            }`}
        >
          Polls
        </Link>
        <Link
          to={`/${slug1}/predictions_post`}
          className={`py-2 nav-link-hover-poll ${location.pathname === `/${slug1}/prediction`
            ? "font-bold current-page "
            : "text-[#7F8FA4]"
            }`}
        >
          Predictions
        </Link>
      </div>
      <div className="bg_home md:bg-[#F7F8FA] px-4 min-[955px]:px-40 flex flex-col pb-6 md:py-5">
        <div className="bg-white w-full rounded-xl shadow-sm p-3 md:p-5 overflow-hidden">
          <div className="h-auto pb-5">
            <div className="flex flex-col gap-1">
              <div className="flex flex-row justify-start items-center gap-2">
                <div className="size-[20px]">
                  {/* <img
                    src={delhimap}
                    alt="delhi-map"
                    className="object-contain"
                  /> */}
                </div>
                <div className="text-[20px] font-semibold">
                  {/* {console.log("heading", heading)} */}
                  {formatBreadcrumbName(heading)}
                </div>
              </div>
            </div>
          </div>
          <div className="h-auto">
            <div className="my-5">
              <div className="flex flex-wrap justify-start items-center mb-4 gap-5">
                <div className="my-5">
                  <FormControl
                    className="w-[7rem] md:w-[15rem]"
                    variant="outlined"
                  >
                    <InputLabel id="select-Type-label">Select Type</InputLabel>
                    <Select
                      labelId="select-Type-label"
                      id="selectType"
                      name="type"
                      value={searchData?.type}
                      onChange={handleChange}
                      label="Select Type"
                      sx={{ borderRadius: "0.75rem" }}
                    >
                      <MenuItem value="poll_prediction">
                        Poll Prediction
                      </MenuItem>
                      <MenuItem value="final_result">Final Result</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="my-5">
                  <FormControl
                    className="w-[8rem] md:w-[15rem]"
                    variant="outlined"
                  >
                    <InputLabel id="select-Year-label">Select Year</InputLabel>
                    <Select
                      labelId="select-Year-label"
                      id="selectYear"
                      name="year"
                      value={searchData?.year}
                      label="Select Year"
                      onChange={handleChange}
                      sx={{ borderRadius: "0.75rem" }}
                    >
                      {delhiPollsYearsResponse?.map((item) => {
                        return (
                          <MenuItem value={item?.year}>{item?.year}</MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
                <button
                  className="px-12 py-3 bg-[#E4002B] text-white rounded-lg active:scale-90 transition-all duration-75"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
            <div className="text-[21px] font-semibold">
              {delhiElectionData ? "Average of Polls" : "Voteshare"}
            </div>
            <div className="flex flex-col gap-1">
              <div className="flex flex-row justify-between mb-14">

                <div className="grid grid-cols-1 md:grid-cols-2 w-full">
                  <div className="mb-5">
                    <div className="text-[21px] font-semibold my-5">
                      Seats
                    </div>
                    <HorizontalBar barData={pieData} />
                  </div>
                  <div>
                    <div className="text-[21px] font-semibold my-5">
                      Vote Share
                    </div>
                    {showPie ? (
                      <div className="w-full max-w-[100%] md:w-[38vw] h-[20rem]">
                        {!loading ? (
                          <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                              <Pie
                                data={barData}
                                innerRadius="40%"
                                outerRadius="70%"
                                paddingAngle={3}
                                dataKey="value"
                                labelLine={false}
                                label={({ cx, cy, midAngle, innerRadius, outerRadius, index }) => {
                                  const RADIAN = Math.PI / 180;
                                  const sliceData = barData[index];

                                  const radius = innerRadius + (outerRadius - innerRadius) * 1.1;
                                  const circleX = cx + radius * Math.cos(-midAngle * RADIAN);
                                  const circleY = cy + radius * Math.sin(-midAngle * RADIAN);

                                  const labelRadius = outerRadius + 30;
                                  const labelX = cx + labelRadius * Math.cos(-midAngle * RADIAN);
                                  const labelY = cy + labelRadius * Math.sin(-midAngle * RADIAN);

                                  return (
                                    <g>
                                      {sliceData?.seat > 0 && (
                                        <>
                                          <circle
                                            cx={circleX}
                                            cy={circleY}
                                            r={20}
                                            fill="red"
                                            stroke="white"
                                            strokeWidth={3}
                                          />
                                          <text
                                            x={circleX}
                                            y={circleY}
                                            fill="white"
                                            textAnchor="middle"
                                            dominantBaseline="central"
                                            style={{ fontSize: "12px", fontWeight: "bold" }}
                                          >
                                            {sliceData?.seat}%
                                          </text>

                                          <text
                                            x={labelX}
                                            y={labelY}
                                            fill="#333"
                                            textAnchor={labelX > cx ? "start" : "end"}
                                            dominantBaseline="central"
                                            style={{ fontSize: "14px", fontWeight: "600" }}
                                          >
                                            {sliceData?.name}
                                          </text>
                                        </>
                                      )}
                                    </g>
                                  );
                                }}
                              >
                                {barData?.map((entry, index) => (
                                  <Cell key={`cell-${index}`} fill={entry?.color} />
                                ))}
                              </Pie>
                            </PieChart>
                          </ResponsiveContainer>
                        ) : (
                          <>
                            <div className="w-[85vw] md:w-[38vw] h-[20.5rem] flex justify-center items-center relative">
                              <div className="skeleton-loader size-60 rounded-full relative">
                                <div className="w-16 h-6 rotate-12 bg-white absolute top-24"></div>
                                <div className="w-6 h-20 rotate-[60deg] bg-white absolute top-[3.5rem] left-[12rem]"></div>
                                <div className="w-6 h-20 rotate-[150deg] bg-white absolute bottom-[0.5rem] left-[10rem]"></div>
                                <div className="size-36 rounded-full bg-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    ) : (
                      <div className="text-3xl text-gray-400">No Data</div>
                    )}
                  </div>



                </div>
              </div>
            </div>
            {/* <div className="flex justify-center my-5">
              <CustomLegend />
            </div> */}
            {/* Polling chart end */}
            {/* {delhiElectionData && ( */}
            <div
              className={` 
                  flex flex-col gap-3
              `}
            >
              <div className="text-[21px] font-semibold">Polling Table</div>

              <PollingTable
                delhiElectionData={delhiElectionData}
                type={searchData.type}
                metaData={partyMetaDataList}
              />
            </div>
            {/* )} */}
            <div className="py-6 hidden">
              <div className="text-[12px] text-gray-700 font-semibold">
                Summary
              </div>
              <p
                className="text-[12px] text-gray-500 py-2 leading-5 text-justify"
                onMouseEnter={() => {
                  // console.log();
                }}
              >
                {/* Summary content */}
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean
                vel auctor magna, ut tristique sapien. Nunc ut ligula placerat,
                tempus risus sed, vehicula massa. Sed rutrum ultrices libero,
                sit amet suscipit magna vulputate vel. Curabitur hendrerit
                ornare risus. Praesent et eleifend neque. Nam eget massa massa.
                Fusce orci augue, egestas vitae ultrices eu, facilisis at lacus.
                Donec condimentum eros at justo hendrerit, vitae congue purus
                eleifend. Nam facilisis nulla sem, ac bibendum felis accumsan
                at. Proin hendrerit ac ipsum non lobortis. Proin eget porta
                turpis, in rhoncus massa. Donec sit amet nibh et mi congue
                pretium quis eu nibh. Pellentesque tempus sem ac orci rhoncus
                hendrerit. Aenean vitae orci ut diam sollicitudin tincidunt sit
                amet ac lectus. Proin felis sem, pellentesque sit amet diam
                vitae, suscipit fermentum est. Vestibulum quis vulputate felis.
                Nullam ut orci non metus eleifend condimentum eget et mi. Morbi
                rhoncus commodo est sed sodales. Vestibulum vehicula ligula
                risus, ut vulputate nulla pretium vel. Quisque semper nulla
                lorem, sed ultricies lectus venenatis nec. Proin non mi pretium,
                cursus ligula ac, suscipit nisi. Pellentesque mollis sodales
                ligula a feugiat. Sed in neque quis dolor ullamcorper auctor
                quis ac ipsum. Quisque at nisi sed sapien aliquam laoreet eget
                eget dolor. Donec euismod enim lectus, eu elementum mi facilisis
                ut. Curabitur ultrices nulla a magna laoreet sollicitudin.
              </p>
            </div>

            {/* prediction Modal  */}

            {/* <div className="py-6">
              <div className="flex justify-between items-center">
                <div className="text-[16px]">
                  <p>Users Predictions</p>
                </div>
                <button
                  disabled
                  className="px-3 py-2 bg-[#012169] text-white text-[12px] rounded-full opacity-35"
                >
                  view All
                </button>
              </div>
              <div className="flex ">
                <div className="relative w-[21rem] h-[10rem] rounded-2xl overflow-hidden bg-gray-50 cursor-pointer">
                  <div className="p-1 text-[10px] bg-black text-white flex justify-start gap-3 items-center font-semibold">
                    <div className="rounded-full border size-6 bg-gray-300"></div>
                    <p>Subhas’s Arizona Prediction</p>
                  </div>
                  <div className="grid grid-cols-1 mx-2 ">
                    <div className="flex gap-1 h-6 items-end">
                      <p className="w-4 text-[8px]">100</p>
                      <div className="border-b border-black w-full"></div>
                    </div>
                    <div className="flex gap-1 h-6 items-end">
                      <p className="w-4 text-[8px]">75</p>
                      <div className="border-b border-black w-full"></div>
                    </div>
                    <div className="flex gap-1 h-6 items-end">
                      <p className="w-4 text-[8px]">50</p>
                      <div className="border-b border-black w-full"></div>
                    </div>
                    <div className="flex gap-1 h-6 items-end">
                      <p className="w-4 text-[8px]">25</p>
                      <div className="border-b border-black w-full"></div>
                    </div>
                    <div className="flex gap-1 h-6 items-end">
                      <p className="w-4 text-[8px]">0</p>
                      <div className="border-b-4 border-gray-500 w-full"></div>
                    </div>
                  </div>
                  <div className="h-[6.25rem] pb-2 flex justify-center gap-5 mx-8 absolute top-[52px] left-14 ">
                    <div className="flex items-end justify-center gap-1 h-[6rem]">
                      <div className="border w-6 h-[5rem] bg-[#4252A8]"></div>
                      <div className="border w-6 h-[5.6rem] bg-[#E60800]"></div>
                    </div>
                    <div className="flex items-end justify-center gap-1 h-[6rem]">
                      <div className="border w-6 h-[4.6rem] bg-[#4252A8]"></div>
                      <div className="border w-6 h-[5.4rem] bg-[#E60800]"></div>
                    </div>
                    <div className="flex items-end justify-center gap-1 h-[6rem]">
                      <div className="border w-6 h-[0.6rem] bg-[#4252A8]"></div>
                      <div className="border w-6 h-[1rem] bg-[#E60800]"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Delhipolls;
